<template>
    <div>
        <label>{{ label }}</label>
        <div style="position: relative; display: block; width: 100%; padding: 0 .25rem 1rem">
            <ui-select
                :disabled="disabled"
                v-model="from"
                style="width: 45%; display: inline-block;"
                :options="fromRange"
                @input="change"
                placeholder="Any"
            >
                From
            </ui-select>
            <ui-select
                :disabled="disabled"
                v-model="to"
                style="width: 45%; display: inline-block;"
                :options="toRange"
                @input="change"
                placeholder="Any"
            >
                To
            </ui-select>
        </div>
    </div>
</template>

<script>
    import Filters from '../../../filters'

    export default {
        filters: Filters,
        props: {
            label: {
                type: String,
                default: 'Default Label',
            },
            value: {
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            config: {
                type: Object,
                default() {
                    return {
                        fromRange: [
                            {value: 0, label: 'Placeholder Minimum'},
                        ],
                        toRange: [
                            {value: 0, label: 'Placeholder Maximum'},
                        ],
                    }
                }
            }
        },
        created() {
            this.setPriceFromValue();
        },
        watch: {
            value: {
                handler: function(n, o) {
                    if (n !== o) {
                        this.setPriceFromValue();
                    }
                }
            }
        },
        methods: {
            setPriceFromValue() {
                if (this.value && '%' !== this.value && typeof this.value === 'object') {
                    this.from = this.fromRange.find(item => item.value === this.value[0])
                    this.to = this.toRange.find(item => item.value === this.value[1])
                } else if (this.fromRange && this.fromRange.length > 0) {
                    this.from = this.fromRange[0]
                    this.to = this.toRange[this.toRange.length - 1]
                }
            },
            change() {
                if (this.from && this.to) {
                    this.$emit('input', [this.from.value, this.to.value])
                }
            }
        },
        computed: {
            fromRange() {
                return this.config.fromRange
            },
            toRange() {
                return this.config.toRange
            },
        },
        data() {
            return {
                from: null,
                to: null,
            }
        }
    }
</script>